import { ThemesColorsEnum } from './interfaces/themes-colors.enum';
import { ThemeManagement } from './services/theme-management.service';
import { AuthService } from './services/auth.service';
import { LocalStorageService } from './services/local-storage.service';
import { EVENT_COLORS } from './maps/event-colors';
import { CORES_STATUS_REGISTRO_DIARIO } from './maps/registro-diario-status-color';
import { CORES_STATUS_SOLICITACAO } from './maps/solicitacao-status-colors';
import { CORES_COMUNICADOS } from './maps/comunicados-colors';
import { APPS } from './environments/apps';
import { AppHelper } from './helpers/env-helper';
import { CommunicationService } from './services/communication.service';
import { ToolbarBuilder } from './helpers/toolbar.builder';
import { ToolbarService } from './services/toolbar.service';
import { ERROR_CODE_MESSAGES } from './messages/error/error-messages';
import { ParceiroService } from './services/parceiro.service';
import { ClientService } from './services/client.service';
ThemeManagement.singleton().initListener();
export { ThemeManagement, ThemesColorsEnum };
export { AuthService, LocalStorageService, CommunicationService, ParceiroService, ClientService };
export { EVENT_COLORS, CORES_STATUS_REGISTRO_DIARIO, CORES_STATUS_SOLICITACAO, CORES_COMUNICADOS };
export { APPS };
export { AppHelper };
export { ToolbarBuilder, ToolbarService };
export { ERROR_CODE_MESSAGES };
